import React, { FC } from 'react';

import '../../css/Title.scss';

const Title: FC = (): JSX.Element => {
    return <h1 className="blinking">CatiClick</h1>;
};

export default Title;
